import { log } from '../../util/log';
import { BookingContext } from '../../util/booking-context';
import { callWp } from '../../util/call-wp';
import { hideLoadingOverlay, showLoadingOverlay } from '../../util/loading-overlay';
import { loadChooseServicesPage } from './choose-services';
import { getCookie } from '../../util/cookie';

export async function loadSelectLocationPage(context: BookingContext) {
	window.scroll(0, 0);
	log('Loading select location page');
	showLoadingOverlay(context);
	context.root.innerHTML = '';
	const ssrStartTime = performance.now();
	const ssrResponse = await callWp('GET', 'view_select_location', context.data);
	const ssrEndTime = performance.now();
	log('SSR took', ssrEndTime - ssrStartTime, 'ms');

	// if (ssrResponse === null) {
	// 	// redirect to my account (user is not signed in)
	// 	window.location.href = `${silkNexusWp.myAccountUrl}?redirect_to_booking=1`;
	// 	return;
	// }

	const html = ssrResponse.html;
	context.root.innerHTML = html;
	hideLoadingOverlay(context);

	if (context.data.locationName === null || context.data.locationId === null) {
		const locationName = getCookie('location');
		const locationId = '' + getCookie('location_id');

		if (locationName.length > 0 && locationId.length > 0) {
			context.data.locationName = locationName;
			context.data.locationId = parseInt(locationId);
		}
	}

	context.root.querySelectorAll<HTMLButtonElement>('button[data-reload]').forEach((b) => b.addEventListener('click', () => loadSelectLocationPage(context)));

	const nextButton = context.root.querySelector<HTMLButtonElement>('[data-next]');
	if (!nextButton) {
		log('No next button found');
		return;
	}

	const clinicSelectedSection = context.root.querySelector<HTMLDivElement>('[data-clinic-selected]');
	if (!clinicSelectedSection) {
		log('No clinic selected section found');
		return;
	}

	const clinicSelectedNone = context.root.querySelector<HTMLDivElement>('[data-clinic-none]');
	if (!clinicSelectedNone) {
		log('No clinic selected none found');
		return;
	}

	const selectClinic = (clinic: { id: number; name: string } | null) => {
		clinicSelectedNone.classList.toggle('hidden', clinic !== null);
		clinicSelectedSection.classList.toggle('hidden', clinic === null);
		clinicSelectedSection.querySelector<HTMLDivElement>('[data-clinic-name]')!.innerText = clinic?.name ?? '';
		nextButton.disabled = clinic === null;
	};

	selectClinic(
		context.data.locationId
			? {
					id: context.data.locationId,
					name: context.data.locationName ?? '',
			  }
			: null
	);

	context.root.querySelectorAll<HTMLButtonElement>('[data-open-clinic-selector]').forEach((b) => b.addEventListener('click', showLocationModal));

	type LocationChangedEvent = CustomEvent & {
		detail: {
			id: number;
			name: string;
		};
	};

	function handleLocationChange(e: Event) {
		const event = e as LocationChangedEvent;
		const clinic = event.detail;

		context.data.locationId = clinic.id;
		context.data.locationName = clinic.name;

		selectClinic(clinic);
	}
	document.addEventListener('locationchange', handleLocationChange);

	nextButton.addEventListener('click', async () => {
		document.removeEventListener('locationchange', handleLocationChange);
		loadChooseServicesPage(context);
	});

	// data-clinic-selected
	// data-clinic-none

	// data-clinic-name
	// data-next

	// data-open-clinic-selector

	// TODO: Add event listeners
}
